import {
	CustomQuoteConfirmationSubTitle,
	ExportConfirmationText,
	GeneratingPDFText,
	PDFDownloadText,
	PDFErrorText,
	ReplacementConfirmationHeader,
	ReturnToCustomQuoteButtonText
} from "constants/text";
import {
	ConfirmationPageHeaderContainer,
	ConfirmationPageHeaderSubtitle,
	ConfirmationPageHeaderTitle,
	ConfirmationPageHeaderTitleContainer,
	ConfirmationPageHeaderWrapper,
	ConfirmationPageWrapper,
	ReturnButtonContainer
} from "./CustomQuoteConfirmationPage.styles";
import { Button, Paper } from "@mui/material";
import ExportButtons from "components/ExportFile/ExportButtons";
import { useNavigate, useParams } from "react-router";
import { useGetCustomQuoteByIdQuery } from "features/api/customQuotesApi";
import { CustomQuoteDetail } from "components/CustomQuote/CustomQuoteDetail/CustomQuoteDetail";
import useCustomQuoteDetailsPDFGenerator from "hooks/useCustomQuoteDetailsPDFGenerator";
import { useGetBillToInfoQuery } from "features/api/accountApi";
import useSnackbarEffect from "hooks/useSnackbarEffect";
import Snackbar from "components/Common/SnackBar/SnackBar.tsx";
import useHandlePopState from "hooks/useHandlePopState.ts";
import { useMemo } from "react";

export const CustomQuoteConfirmationPage = () => {
	const { quoteId } = useParams<{ quoteId: string }>();
	const { data: quote } = useGetCustomQuoteByIdQuery(quoteId);
	const navigateTo = useNavigate();
	const billToInfoQueryArgs = useMemo(
		() => ({ accountId: quote?.accountId, billToId: quote?.billToId }),
		[quote?.accountId, quote?.billToId]
	);
	const { data: billTo } = useGetBillToInfoQuery(billToInfoQueryArgs);

	const { pdfData, generateCustomQuotePDF } = useCustomQuoteDetailsPDFGenerator(quote, billTo);
	const { snackbarOpen } = useSnackbarEffect(pdfData.loading);

	const returnToNewOrders = () => {
		navigateTo("/custom-quote");
	};

	useHandlePopState({
		title: "Custom Quote Confirmation",
		path: "/custom-quote"
	});

	return (
		<>
			<ConfirmationPageHeaderWrapper>
				<ConfirmationPageHeaderContainer>
					<ConfirmationPageHeaderTitleContainer>
						<ConfirmationPageHeaderTitle data-testid="custom-quote-confirmation-header">
							{ReplacementConfirmationHeader}
						</ConfirmationPageHeaderTitle>
						<ExportButtons
							largePDF={false}
							buttonHeader={ExportConfirmationText}
							generatePDF={generateCustomQuotePDF}
							isOnlyPDF
						/>
						<Snackbar
							open={snackbarOpen}
							isLoading={pdfData.loading}
							loadingText={GeneratingPDFText}
							successText={PDFDownloadText}
							errorText={PDFErrorText}
							isError={Boolean(pdfData.error)}
						/>
					</ConfirmationPageHeaderTitleContainer>
					<ConfirmationPageHeaderSubtitle data-testid="custom-quote-confirmation-subtitle">
						{CustomQuoteConfirmationSubTitle}
					</ConfirmationPageHeaderSubtitle>
				</ConfirmationPageHeaderContainer>
				<ReturnButtonContainer>
					<Button
						variant="contained"
						size="large"
						onClick={returnToNewOrders}
						data-testid="custom-quote-confirmation-details-button"
						data-id="custom-quote-confirmation-details-button"
					>
						{ReturnToCustomQuoteButtonText}
					</Button>
				</ReturnButtonContainer>
			</ConfirmationPageHeaderWrapper>
			<ConfirmationPageWrapper>
				<Paper
					elevation={1}
					data-testid="custom-quote-detail-container"
				>
					{quote && <CustomQuoteDetail quote={quote} />}
				</Paper>
			</ConfirmationPageWrapper>
		</>
	);
};
